import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MenuHeaderBackgroundAssetComponent } from '../../menu-header-background-asset/menu-header-background-asset.component';

@Component({
  selector: 'app-menu-header-plantlife-one-column',
  templateUrl: './menu-header-plantlife-one-column.component.html',
  providers: [{ provide: MenuHeaderBackgroundAssetComponent, useExisting: MenuHeaderPlantlifeOneColumnComponent }],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class MenuHeaderPlantlifeOneColumnComponent extends MenuHeaderBackgroundAssetComponent {}
